<div class="ingest-tree-header">
    <h3>Ingest Folder</h3>
    <button mat-icon-button color="primary" matTooltip="Refresh" (click)="refresh()" [disabled]="isLoading">
        <mat-icon>refresh</mat-icon>
    </button>
</div>

<div class="center" *ngIf="isLoading">
    <mat-spinner diameter="32"></mat-spinner>
</div>

<mat-tree *ngIf="!isLoading" [dataSource]="dataSource" [treeControl]="treeControl" class="ingest-tree">
    <!-- File leaf node. Hover styling lives on our own plain "node-row" div,
         not directly on <mat-tree-node> - Material's MDC tree node paints an
         internal state-layer above its host content, which otherwise hides
         any background-color set on the host element itself. -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <div class="node-row">
            <button mat-icon-button disabled></button>
            <mat-icon class="mat-icon-rtl-mirror">insert_drive_file</mat-icon>
            <span class="node-name" [matTooltip]="node.sizeBytes ? formatBytes(node.sizeBytes) : ''">{{node.name}}</span>
            <span class="spacer"></span>
            <button mat-icon-button class="delete-btn" title="Delete File" (click)="onDeleteClicked(node)">
                <mat-icon class="icon red-icon">delete_forever</mat-icon>
            </button>
        </div>
    </mat-tree-node>

    <!-- Folder node -->
    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
        <div class="node-row">
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">{{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}</mat-icon>
            </button>
            <mat-icon class="mat-icon-rtl-mirror yellow-icon">{{treeControl.isExpanded(node) ? 'folder_open' : 'folder'}}</mat-icon>
            <span class="node-name">{{node.name}}</span>
        </div>
    </mat-tree-node>
</mat-tree>

<div class="empty-state" *ngIf="!isLoading && treeControl.dataNodes.length <= 1">
    No files found.
</div>
